// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IDelinquentClaimsSummaryRecordDto
 */
export interface IDelinquentClaimsSummaryRecordDto {
    /**
     * 
     * @type {string}
     * @memberof IDelinquentClaimsSummaryRecordDto
     */
    plan_name?: string;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsSummaryRecordDto
     */
    paid_requiring_docs_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsSummaryRecordDto
     */
    repayment_required_count?: number;
    /**
     * 
     * @type {number}
     * @memberof IDelinquentClaimsSummaryRecordDto
     */
    locked_purses_count?: number;
}

/**
 * Check if a given object implements the IDelinquentClaimsSummaryRecordDto interface.
 */
export function instanceOfIDelinquentClaimsSummaryRecordDto(value: object): value is IDelinquentClaimsSummaryRecordDto {
    return true;
}

export function IDelinquentClaimsSummaryRecordDtoFromJSON(json: any): IDelinquentClaimsSummaryRecordDto {
    return IDelinquentClaimsSummaryRecordDtoFromJSONTyped(json, false);
}

export function IDelinquentClaimsSummaryRecordDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IDelinquentClaimsSummaryRecordDto {
    if (json == null) {
        return json;
    }
    return {
        
        'plan_name': json['plan_name'] == null ? undefined : json['plan_name'],
        'paid_requiring_docs_count': json['paid_requiring_docs_count'] == null ? undefined : json['paid_requiring_docs_count'],
        'repayment_required_count': json['repayment_required_count'] == null ? undefined : json['repayment_required_count'],
        'locked_purses_count': json['locked_purses_count'] == null ? undefined : json['locked_purses_count'],
    };
}

export function IDelinquentClaimsSummaryRecordDtoToJSON(json: any): IDelinquentClaimsSummaryRecordDto {
    return IDelinquentClaimsSummaryRecordDtoToJSONTyped(json, false);
}

export function IDelinquentClaimsSummaryRecordDtoToJSONTyped(value?: IDelinquentClaimsSummaryRecordDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'plan_name': value['plan_name'],
        'paid_requiring_docs_count': value['paid_requiring_docs_count'],
        'repayment_required_count': value['repayment_required_count'],
        'locked_purses_count': value['locked_purses_count'],
    };
}

